module.exports = __webpack_public_path__ + "img/mo.93e1067b.svg";